/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HappeningEdit_happening$ref = any;
type HappeningEdit_lists$ref = any;
export type HappeningEditQueryVariables = {|
  happeningId: string
|};
export type HappeningEditQueryResponse = {|
  +happening: ?{|
    +$fragmentRefs: HappeningEdit_happening$ref
  |},
  +lists: ?{|
    +$fragmentRefs: HappeningEdit_lists$ref
  |},
|};
export type HappeningEditQuery = {|
  variables: HappeningEditQueryVariables,
  response: HappeningEditQueryResponse,
|};
*/


/*
query HappeningEditQuery(
  $happeningId: ID!
) {
  happening: heroOffer(id: $happeningId) {
    ...HappeningEdit_happening
    id
  }
  lists {
    ...HappeningEdit_lists
    id
  }
}

fragment HappeningEdit_happening on HeroOffer {
  id
  title
  url
  imageUrl
  startDate
  endDate
  description
  details
  callToAction
  store {
    id
  }
}

fragment HappeningEdit_lists on Lists {
  id
  stores(first: 1000) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "happeningId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "happeningId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HappeningEditQuery",
    "selections": [
      {
        "alias": "happening",
        "args": (v1/*: any*/),
        "concreteType": "HeroOffer",
        "kind": "LinkedField",
        "name": "heroOffer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HappeningEdit_happening"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HappeningEdit_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HappeningEditQuery",
    "selections": [
      {
        "alias": "happening",
        "args": (v1/*: any*/),
        "concreteType": "HeroOffer",
        "kind": "LinkedField",
        "name": "heroOffer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "details",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "callToAction",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000
              }
            ],
            "concreteType": "StoreConnection",
            "kind": "LinkedField",
            "name": "stores",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "stores(first:1000)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "HappeningEditQuery",
    "operationKind": "query",
    "text": "query HappeningEditQuery(\n  $happeningId: ID!\n) {\n  happening: heroOffer(id: $happeningId) {\n    ...HappeningEdit_happening\n    id\n  }\n  lists {\n    ...HappeningEdit_lists\n    id\n  }\n}\n\nfragment HappeningEdit_happening on HeroOffer {\n  id\n  title\n  url\n  imageUrl\n  startDate\n  endDate\n  description\n  details\n  callToAction\n  store {\n    id\n  }\n}\n\nfragment HappeningEdit_lists on Lists {\n  id\n  stores(first: 1000) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '828faf6638bf3ac3171608ac64fe9fe6';

module.exports = node;
